<template>
  <div class="report-page">
    <div class="section-card">
      <el-form :model="formData" class="report-form" label-width="90px">
        <el-form-item :label="$t('msg.Begin_Date')">
          <el-date-picker type="date" value-format="yyyy-MM-dd" :editable="false"
            :picker-options="pickerOptions" :placeholder="$t('msg.Select_date')"
            v-model="formData.date1" class="report-date-picker" />
        </el-form-item>
        <el-form-item :label="$t('msg.End_Date')">
          <el-date-picker type="date" value-format="yyyy-MM-dd" :editable="false"
            :picker-options="pickerOptions" :placeholder="$t('msg.Select_date')"
            v-model="formData.date3" class="report-date-picker" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchReport">{{ $t('msg.OK2') }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="section-card result-card">
      <el-table :data="tableData" tooltip-effect="dark" size="small"
                stripe border
                :header-cell-style="{background:'#f5f7fa', color:'#303133', fontSize:'12px', fontWeight:'600'}"
                class="report-table">
        <el-table-column prop="date" :label="$t('msg.Date_Time1')" min-width="120">
        </el-table-column>
        <el-table-column prop="total_bet" label="Total Bet" min-width="130" align="right">
        </el-table-column>
        <el-table-column prop="total_win" label="Total Win" min-width="130" align="right">
          <template slot-scope="scope">
            <span :class="scope.row.total_win >= 0 ? 'amount-up' : 'amount-down'">{{ scope.row.total_win }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="player_count" label="Players" min-width="100" align="right">
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="total > 0"
        background
        layout="total, prev, pager, next"
        :total="total"
        :page-size="20"
        :current-page="page"
        @current-change="handlePageChange"
        class="report-pagination"
      />
    </div>
  </div>
</template>

<script>
import { GetPlayersDailyReport } from '../api';
export default {
  name: "AllQueryReport",
  data() {
    return {
      formData: { date1: '', date3: '' },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1)
        }
      },
      tableData: [],
      total: 0,
      page: 1
    }
  },
  methods: {
    fetchReport() {
      if (!this.formData.date1 || !this.formData.date3) {
        this.$message({ message: this.$t('msg.Please_enter_the_time'), type: 'error', offset: 80 });
        return
      }
      this.page = 1
      this.doFetch()
    },
    doFetch() {
      var params = {
        "start_time": this.formData.date1,
        "end_time": this.formData.date3,
        "page": this.page
      }
      GetPlayersDailyReport(params).then((data) => {
        if (data.data.errcode === 0 && data.data.params.status === 0) {
          this.tableData = data.data.params.data || []
          this.total = data.data.params.total || 0
          if (this.tableData.length === 0) {
            this.$alert(this.$t('msg.No_Data'), '', { confirmButtonText: this.$t('msg.OK2'), center: true, customClass: 'alert' });
          }
        } else {
          var msg = data.data.params.msg || this.$t('msg.Failed_to_obtain_data')
          this.$message({ message: msg, type: 'error', offset: 80 });
        }
      })
    },
    handlePageChange(page) {
      this.page = page
      this.doFetch()
    }
  },
  mounted() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    this.formData.date1 = `${year}-${month}-${day}`;
    this.formData.date3 = `${year}-${month}-${day}`;
  }
}
</script>

<style lang="less" scoped>
.report-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
  padding: 20px 24px;
}

.result-card {
  padding: 16px 24px;
  overflow-x: auto;
}

.report-form {
  .el-form-item {
    margin-bottom: 14px;
  }
  .el-form-item:last-child {
    margin-bottom: 0;
  }
}

.report-date-picker {
  width: 220px !important;
}

.report-table {
  width: 100%;
}

.report-pagination {
  margin-top: 16px;
  text-align: right;
}

.amount-up { color: #67c23a; font-weight: 600; }
.amount-down { color: #f56c6c; font-weight: 600; }
</style>



// WEBPACK FOOTER //
// src/views/AllQueryReport.vue